export default __webpack_public_path__ + "static/media/Snd_CX.0e54ee29.mp3";